import styled from '@/styles';
import { dependabilityV2Colors } from '@/styles/colors';

// Chrome for this feature's popovers — elements/Popover is a bare positioning
// primitive, so every popover surface must paint its own background.
const PopoverSurface = styled('div', {
  backgroundColor: dependabilityV2Colors.depSurface,
  border: `1px solid ${dependabilityV2Colors.depBorder}`,
  borderRadius: '8px',
  // exact popover shadow from the tier-popover frame (37858-31304)
  boxShadow: '0px 4px 6px 0px rgba(0, 0, 0, 0.12)',
});

export default PopoverSurface;
